import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_branch = async (branch) => {
  try {
    let data = new FormData();
    data.append("image", branch?.image[0]);
    data.append("name", branch?.name);
    data.append("email", branch?.email);
    data.append("phone", branch?.phone);
    data.append("tax", branch?.tax);
    data.append("area", branch?.area);
    data.append("city", branch?.city);
    data.append("state", branch?.state);
    data.append("country", branch?.country);
    data.append("status", branch?.status);
    data.append("billing", branch?.billing);
    data.append("bank_name", branch?.bank_name || "");
    data.append("bank_branch", branch?.bank_branch || "");
    data.append("bank_account_name", branch?.bank_account_name || "");
    data.append("bank_account_number", branch?.bank_account_number || "");
    data.append("bank_swift", branch?.bank_swift || "");
    data.append("fiscal_years", JSON.stringify(branch?.fiscal_years || []));

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-branch`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_branch = async (branch) => {
  try {
    let data = new FormData();
    data.append("id", branch?.id);
    data.append("image", branch?.image[0]);
    data.append("name", branch?.name);
    data.append("email", branch?.email);
    data.append("phone", branch?.phone);
    data.append("tax", branch?.tax);
    data.append("area", branch?.area);
    data.append("city", branch?.city);
    data.append("state", branch?.state);
    data.append("country", branch?.country);
    data.append("status", branch?.status);
    data.append("billing", branch?.billing);
    data.append("bank_name", branch?.bank_name || "");
    data.append("bank_branch", branch?.bank_branch || "");
    data.append("bank_account_name", branch?.bank_account_name || "");
    data.append("bank_account_number", branch?.bank_account_number || "");
    data.append("bank_swift", branch?.bank_swift || "");
    data.append("fiscal_years", JSON.stringify(branch?.fiscal_years || []));

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/update-branch`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_branch = async (branch) => {
  try {
    const data = {
      id: branch?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-branch`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_branches = async (branch) => {
  try {
    const data = {
      search: branch?.search,
      sort: branch?.sort,
      unit: branch?.unit,
      category: branch?.category,
      brand: branch?.brand,
      type: branch?.type,
      status: branch?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-branches`,
      data,
      config,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_sub_branches = async (branch) => {
  try {
    const data = {
      search: branch?.search,
      sort: branch?.sort,
      unit: branch?.unit,
      category: branch?.category,
      brand: branch?.brand,
      type: branch?.type,
      status: branch?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-sub-branches`,
      data,
      config,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_auth_branch = async (branch) => {
  try {
    const data = {
      // id: branch?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-auth-branch`,
      data,
      config,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_sub_branches = async () => {
  try {
    const data = {};
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-sub-branches`,
      data,
      config,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const switch_branch_token = async (branchId) => {
  try {
    const data = {
      branchId: branchId,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/switch-branch-token`,
      data,
      config,
    );

    return await response.data;
  } catch (error) {
    console.error("Switch branch error:", error);
    return { status: false, message: "Network error" };
  }
};

const clear_switch_branch = async () => {
  try {
    const data = {};

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/clear-switch-branch`,
      data,
      config,
    );

    return await response.data;
  } catch (error) {
    console.error("Clear switch error:", error);
    return { status: false, message: "Network error" };
  }
};

const get_all_main_branches = async () => {
  try {
    const data = {};

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-main-branches-with-details`,
      data,
      config,
    );

    return await response.data;
  } catch (error) {
    console.error("Clear switch error:", error);
    return { status: false, message: "Network error" };
  }
};

export {
  create_branch,
  update_branch,
  get_branch,
  get_all_branches,
  get_all_sub_branches,
  get_auth_branch,
  get_sub_branches,
  switch_branch_token,
  clear_switch_branch,
  get_all_main_branches,
};
